import {acceptHeader, executeWithErrorResponseHandling} from "../ApiUtilities"
import {joinUrl} from "../../Utilities/UriUtilities";
import { ContentType } from "../../Model/Sales/ContentType";
import {Reseller} from "../../Types/Reseller";
import axios from "axios";
import {isRequestError, RequestError} from "../../Model/RequestError";
import {COUNTER_API_CALLS} from "../../Service/CounterMetricsProvider";
import {CmsContent} from "../../Model/CmsContent/CmsContent";

export const fetchAvailablePlanCardContent = async (
    domain: string,
    reseller: Reseller,
    contentType: ContentType,
): Promise<any> => {
    const endPoint = joinUrl(domain, `/${reseller}/plan/sim-only/cardContent/${contentType}`)
    const headers = acceptHeader()

    const response = await executeWithErrorResponseHandling<any>(() =>
        axios.get(endPoint, {headers: headers}))

    if (isRequestError(response)) {
        COUNTER_API_CALLS.emit({severityNumber: 9, severityText: "INFO", body: "", attributes: {"api": "/{reseller}/plan/sim-only/cardContent/{contentType}", "status": "error"}})
        return response
    } else {
        COUNTER_API_CALLS.emit({severityNumber: 9, severityText: "INFO", body: "", attributes: {"api": "/{reseller}/plan/sim-only/cardContent/{contentType}", "status": "success"}})
        return response.data
    }
}

/**
 * Fetches the HTML content for a plan card
 */
export const fetchPlanCardContent = async (
    domain: string,
    reseller: Reseller,
    contentType: ContentType,
    planCode: string
): Promise<CmsContent[] | RequestError> => {
    const formattedReseller = reseller.toLowerCase()
    const endpoint = joinUrl(domain, `${formattedReseller}/plan/content/${planCode}/${contentType}`)
    const headers = {"Accept": "application/json"}

    const response = await executeWithErrorResponseHandling<any>(() =>
        axios.get<CmsContent[]>(endpoint, {headers: headers}))

    if (isRequestError(response)) {
        COUNTER_API_CALLS.emit({severityNumber: 9, severityText: "INFO", body: "", attributes: {"api": "/content/plan/{planCode}/{contentType}", "status": "error"}})
        return response
    } else {
        COUNTER_API_CALLS.emit({severityNumber: 9, severityText: "INFO", body: "", attributes: {"api": "/content/plan/{planCode}/{contentType}", "status": "success"}})
        return response.data
    }
}